export const ajaxRequest = (method, url, data) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        try {
          const parsed = JSON.parse(this.responseText || '{}');
          if (this.status === 200) {
            resolve(parsed);
          } else {
            reject(parsed);
          }
        } catch (error) {
          reject(error);
        }
      }
    };

    xhr.open(method, url);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    xhr.send(method === 'POST' ? JSON.stringify(data) : null);
  });

export default ajaxRequest;
